// src/api/printedVoucherGameApi.ts
import { http } from "../services/http";

/** ===== Types from your backend response ===== */
export type ValidateResponse = {
  ok: boolean;
  reason?: string | null;
  message?: string | null;
  batchId?: number | null;
  allowedExperiences?: string[];
  alreadyRedeemed?: boolean;
  redeemedAt?: string | null;
};

export type PrizeDto = {
  PrizeId: number;
  code: string;
  name: string;
  type: string;
  valueJson: string;
};

export type RedeemResponse = {
  ok: boolean;
  reason?: string | null;
  message?: string | null;
  redemptionId?: number | null;
  experience?: string;
  prize: PrizeDto | null;
};

export async function validatePrintedVoucher(code: string): Promise<ValidateResponse> {
  const { data } = await http.post("/api/v1/vouchers/printed/validate", { code });
  return data;
}

export async function redeemPrintedVoucher(
  code: string,
  experience: "SPIN" | "GIFTBOX"
): Promise<RedeemResponse> {
  const { data } = await http.post("/api/v1/vouchers/printed/redeem", { code, experience });
  return data;
}
